import ResetPasswordSuccessMessage from './ResetPasswordSuccessMessage'

export default ResetPasswordSuccessMessage
